// @core/api/endpoints/team/get_team_details.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTeamDetailsResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Get detailed team information
 * Returns comprehensive team details including member count, roles, permissions, and associated resources.
 */
export async function GetTeamDetails(
  team_id: string,
  options?: RequestOptions
): Promise<GetTeamDetailsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/details`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<GetTeamDetailsResponse>(requestPath, { ...requestOptions });
}
